import { createInteractor } from './interactor';
export function buildDaisyChain({ interactors }) {
  return createInteractor({ interactors });
}
